import React, { createElement, FC, useEffect, useState } from 'react';
import { ReactComponent as TitleIcon } from 'assets/icons/delivery-settings.svg';
import SurgeTabs from '../surge-tabs';
import { BaseModal } from '@cokitchen/cokitchen-components';
import { Button } from '@cokitchen/cokitchen-components';
import DeliverySurgeApplyNow from './delivery-settings-apply-now';
import DeliverySurgeSchedule from './delivery-settings-schedule';
import DeliverySurgeHistory from './delivery-settings-history';
import { EditSurgeTabType, PolygonSurgeTabProps, SurgeTabType } from '../surge-tabs/types';
import { CoKitchenPolygons } from 'models/cokitchen.model';
import { PolygonsTab } from 'components/base/polygons-tab';
// import AssignFleet from '../general/assign-fleet';
type DeliverySettingsModalProps = {
  defaultPolygon?: CoKitchenPolygons;
  show: boolean;
  onClose: () => void;
};

const DeliverySettingsModal: FC<DeliverySettingsModalProps> = ({
  defaultPolygon,
  show,
  onClose
}) => {
  const [active, setActive] = useState<SurgeTabType>('Apply Now');
  const [trigger, setTrigger] = useState('' as EditSurgeTabType);
  const [loading, setLoading] = useState(false);
  const [activePolygon, setActivePolygon] = useState({} as CoKitchenPolygons);

  useEffect(() => {
    if (show) {
      setTrigger('' as EditSurgeTabType);
      setActive('Apply Now');
      if (defaultPolygon) setActivePolygon(defaultPolygon);
    }
  }, [show]);

  const onConfirm = () => {
    setTrigger(active);
  };

  const tabList: SurgeTabType[] = ['Apply Now', 'Schedule', 'History'];
  const tabComponents: Record<SurgeTabType, any> = {
    'Apply Now': DeliverySurgeApplyNow,
    Schedule: DeliverySurgeSchedule,
    History: DeliverySurgeHistory
    // Fleets: AssignFleet
  };

  const hideConfirmButton = () => {
    return active === 'History';
  };

  return (
    <BaseModal
      isOpen={show}
      title='Delivery Settings'
      description='Manage how customers get their orders'
      titleIcon={<TitleIcon />}
      titleIconColor='success'
      onRequestClose={onClose}
      footer={
        hideConfirmButton() ? undefined : (
          <Button small color='primary' variant='block' loading={loading} onClick={onConfirm}>
            Confirm
          </Button>
        )
      }>
      <div>
        <div className='mt-3'>
          <SurgeTabs list={tabList} active={active} setActive={setActive} />

          <div className='mb-3'>
            <PolygonsTab
              activePolygon={activePolygon}
              defaultPolygon={defaultPolygon}
              setActivePolygon={setActivePolygon}
              smallText
              isModalView
              hasAll
            />
          </div>
        </div>
        {createElement(tabComponents[active] as FC<PolygonSurgeTabProps>, {
          cokitchen_polygon_id: activePolygon.id,
          confirm: trigger,
          setLoading: setLoading,
          onClose: onClose
        })}
      </div>
    </BaseModal>
  );
};

export default DeliverySettingsModal;
